<template>
  <router-view/>
</template>

<style>
.el-popper.is-light {
  /*width: 210px !important;*/
}
.el-popper, .el-menu--popup{
  /*padding: 0 !important;*/
  /*width: 210px !important;*/
  /*min-width: 100px !important;*/
}
</style>
